import React, { useEffect } from "react";
import { ImageInterface } from "src/store/community/imagesSlice";

import { Button, Form } from "antd";
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params?: ImageInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='file' label='Image' preview={params?.file_url} />
      </div>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
